module.exports = __webpack_public_path__ + "static/bg-result-3c08852aa328b79e98a696c973bd283a.png";